module.exports = __webpack_public_path__ + "img/microphone-lines-slash.5580fd47.svg";